export default function localizeDuration({
  duration,
}: {
  duration: { minutes: number; seconds: number }
}) {
  // NOTE: Currently this one lets the build fail: "Property 'DurationFormat' does not exist on type 'typeof Intl'."
  // TODO: Try again with a newer version of TypeScript: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DurationFormat
  // return new Intl.DurationFormat(i18n.language, {
  //   style: 'digital',
  //   hoursDisplay: 'auto',
  //   minutesDisplay: 'always',
  //   secondsDisplay: 'always',
  // }).format(duration)

  const minutes = String(duration.minutes).padStart(2, '0')
  const seconds = String(duration.seconds).padStart(2, '0')

  return `${minutes}:${seconds}`
}
